import { z } from "zod";

export interface ObjectProfilePermission {
    id: number;
    reference_type: number;
    profile: string;
    action_list: "private" | "public" | "none";
    action_retrieve: "private" | "public" | "none";
    action_create: "private" | "public" | "none";
    action_update: "private" | "public" | "none";
    action_delete: "private" | "public" | "none";
    custom_actions: string[];
    use_hierarchy?: boolean;
    fields: string[];
    created_at: string;
    updated_at: string;
}

export interface ObjectProfilePermissionFormData {
    reference_type: number;
    profile: string;
    action_list: "private" | "public" | "none";
    action_retrieve: "private" | "public" | "none";
    action_create: "private" | "public" | "none";
    action_update: "private" | "public" | "none";
    action_delete: "private" | "public" | "none";
    custom_actions: string[];
    use_hierarchy?: boolean;
}

export interface CRMObject {
    reference_type_id: string;
    app_label: string;
    object_name: string;
    label: string;
    endpoint: string;
    icon?: string;
    color?: string;
    fields: string[];
}

// Schéma Zod pour la validation des formulaires de permissions
export const PermissionFormSchema = z.object({
    reference_type: z.number().positive("L'ID du type de référence est requis"),
    profile: z.string().min(1, "Le profil est requis"),
    action_list: z.enum(["private", "public", "none"], {
        required_error: "La permission de liste est requise"
    }),
    action_retrieve: z.enum(["private", "public", "none"], {
        required_error: "La permission de détail est requise"
    }),
    action_create: z.enum(["private", "public", "none"], {
        required_error: "La permission de création est requise"
    }),
    action_update: z.enum(["private", "public", "none"], {
        required_error: "La permission de modification est requise"
    }),
    action_delete: z.enum(["private", "public", "none"], {
        required_error: "La permission de suppression est requise"
    }),
    custom_actions: z.array(z.string()).default([]),
    use_hierarchy: z.boolean().optional().default(false)
});

export type PermissionFormData = z.infer<typeof PermissionFormSchema>;
